import { Campo } from "@/componentes/Campo";
import { Selecao } from "@/componentes/Selecao";
import {
  POLITICAS,
  usaExcedente,
  type CampoDoPlano,
  type ErrosDoPlano,
  type ValoresDoPlano,
} from "./plano";

/*
 * Os campos do plano, compartilhados por criação e edição.
 *
 * O que o rótulo não diz sozinho — vazio é "sem limite", zero é "pague por
 * uso" — está na dica de cada campo, e não em parágrafo embaixo dele.
 */
export function FormularioDePlano({
  valores,
  erros,
  aoMudar,
}: {
  valores: ValoresDoPlano;
  erros: ErrosDoPlano;
  aoMudar: (campo: CampoDoPlano, valor: string) => void;
}) {
  const comExcedente = usaExcedente(valores.politica_excedente);

  return (
    <>
      <Campo
        rotulo="Nome"
        value={valores.nome}
        onChange={(evento) => aoMudar("nome", evento.target.value)}
        erro={erros.nome}
        autoFocus
        required
      />

      <Campo
        rotulo="Descrição"
        value={valores.descricao}
        onChange={(evento) => aoMudar("descricao", evento.target.value)}
        erro={erros.descricao}
      />

      <div className="grid grid-cols-2 gap-3">
        <Campo
          rotulo="Mensalidade (R$)"
          inputMode="decimal"
          placeholder="0,00"
          value={valores.preco_base_centavos}
          onChange={(evento) => aoMudar("preco_base_centavos", evento.target.value)}
          erro={erros.preco_base_centavos}
        />

        <Campo
          rotulo="Franquia"
          inputMode="numeric"
          placeholder="sem limite"
          dica="Boletos por mês incluídos na mensalidade. Vazio: sem limite. Zero: todo boleto é excedente."
          value={valores.limite_mensal}
          onChange={(evento) => aoMudar("limite_mensal", evento.target.value)}
          erro={erros.limite_mensal}
        />
      </div>

      <Selecao
        rotulo="Política"
        dica="O que acontece com a emissão acima da franquia."
        opcoes={POLITICAS}
        value={valores.politica_excedente}
        onChange={(evento) => aoMudar("politica_excedente", evento.target.value)}
        erro={erros.politica_excedente}
      />

      {comExcedente && (
        <div className="grid grid-cols-2 gap-3">
          <Campo
            rotulo="Excedente (R$)"
            inputMode="decimal"
            placeholder="0,00"
            dica="Preço de cada boleto acima da franquia."
            value={valores.preco_excedente_centavos}
            onChange={(evento) => aoMudar("preco_excedente_centavos", evento.target.value)}
            erro={erros.preco_excedente_centavos}
          />

          <Campo
            rotulo="Teto de excedente"
            inputMode="numeric"
            placeholder="ilimitado"
            dica="Máximo de boletos excedentes no mês; acima dele, a emissão é recusada. Vazio: ilimitado."
            value={valores.teto_excedente}
            onChange={(evento) => aoMudar("teto_excedente", evento.target.value)}
            erro={erros.teto_excedente}
          />
        </div>
      )}

      <Campo
        rotulo="Requisições por segundo"
        inputMode="numeric"
        placeholder="padrão"
        dica="Vazio: o padrão do motor."
        className="w-32"
        value={valores.limite_rps}
        onChange={(evento) => aoMudar("limite_rps", evento.target.value)}
        erro={erros.limite_rps}
      />
    </>
  );
}
